import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  padding: 0 1rem 1rem 1rem;
`

export const InputContainer = styled.div`
  padding: 0.5rem 0;
`

export const ButtonContainer = styled.div`
  padding: 2rem 3.75rem;
  text-align: center;
`

export const CheckboxLink = styled.a`
  color: ${(props) => props.theme.colors.grayscale[900]};
  font-family: 'Inter Bold', serif;
`
